module.exports = __webpack_public_path__ + "static/media/virgin.365152fb.png";